import apiClient from '@/plugins/axios';

export default {
	list(params, opts = {}) {
		return apiClient.get('v1/Customer', { params, ...opts });
	},

	getCustomers(params) {
		params.pageNumber = params.currentPage;

		return apiClient.get('v1/Customer', { params });
	},

	getCustomer(customerId) {
		return apiClient.get(`v1/Customer/${customerId}`);
	},

	getCustomerInformation(params, opts = {}) {
		return apiClient.get('v1/CustomerInformation', {params, ...opts});
	},

	getExternalBuildings(userId, opts = {}) {
		return apiClient.get(`v1/CustomerInformation/ExternalBuildings?userId=${userId}`, {...opts});
	},

	createCustomer(customer, opts = {}) {
		return apiClient.post('v1/Customer', customer, opts);
	},

	update(id, body, opts = {}) {
		return apiClient.put(`v1/Customer/${id}`, body, opts);
	},

	updateCustomer(customer) {
		var customerId = customer.id;

		return apiClient.put(`v1/Customer/${customerId}`, customer);
	},

	deleteCustomer(customerId) {
		return apiClient.delete(`v1/Customer/${customerId}`);
	},

	getTree(params, opts = {}) {
		return apiClient.get('/v1/Customer/TreeNode', {params, ...opts});
	},

	getActiveCustomer(params, opts = {}) {
		return apiClient.get('/v1/Customer/GetActiveCustomer', {params, ...opts});
	},

	getRootCustomer(params, opts = {}) {
		return apiClient.get('/v1/Customer/GetRootCustomer', { params, ...opts });
	},

	move(body, opts = {}) {
		return apiClient.put('/v1/Customer/MoveCustomer', body, opts);
	},

	getExternalCustomersOnUser(userId, opts = {}) {
		return apiClient.get(`v1/Customer/GetExternalCustomers?UserId=${userId}`, { ...opts });
	}
};
